import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/styles';
import React from 'react';

import { Colors } from 'src/common/ui/base';
import { GetIdVerificationDataQuery } from 'src/generated/gql/graphql';
import { EditStatusReviewForm } from 'src/idVerification/components/EditStatusReviewForm';

type IdSubmissionDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  mutate: () => void;
  verificationData: GetIdVerificationDataQuery['staff_getIdVerificationData'];
  patientId: string;
};

export const StatusReviewDialog = ({
  isOpen,
  patientId,
  verificationData,
  onClose,
  mutate,
}: IdSubmissionDialogProps) => {
  const styles = useStyles();

  return (
    <Dialog fullWidth maxWidth="lg" open={isOpen} onClose={onClose}>
      <DialogTitle classes={{ root: styles.title }}>Edit Verification Status</DialogTitle>
      <DialogContent>
        <EditStatusReviewForm
          patientId={patientId}
          verificationData={verificationData}
          onClose={onClose}
          mutate={mutate}
        />
      </DialogContent>
    </Dialog>
  );
};

const useStyles = makeStyles({
  title: {
    '& .MuiTypography-root': {
      color: Colors.Gray5,
      fontFamily: 'Tenor Sans',
      fontSize: 24,
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 1.45,
      letterSpacing: 0.2,
    },
  },
});
